import { useEffect } from 'react'
import { usePendingActionCount } from '../features/plans/itemApi'

/**
 * Says out loud when work has not reached the server yet, and blocks an
 * accidental page close while it has not.
 *
 * Optimistic updates are only honest if the app admits what is still in flight.
 * On a venue connection a tap can sit unsent for a while, and closing the tab
 * then would lose it silently.
 */
export function PendingWorkIndicator() {
  const pending = usePendingActionCount()

  useEffect(() => {
    if (pending === 0) {
      return
    }

    const warn = (event: BeforeUnloadEvent) => {
      event.preventDefault()
      // Browsers show their own wording; returnValue is what triggers the prompt.
      event.returnValue = ''
    }

    window.addEventListener('beforeunload', warn)
    return () => window.removeEventListener('beforeunload', warn)
  }, [pending])

  if (pending === 0) {
    return null
  }

  return (
    <div className="pending-banner" role="status" aria-live="polite">
      Saving {pending} change{pending === 1 ? '' : 's'}… don’t close this page yet.
    </div>
  )
}
